// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const setSections = createAction('[Custom PDF Report Modal] Set Sections', props());
